import {
  ERROR_DATA,
  INIT_USER_DATA,
  CURRENT_ENTRY_DATA,
  MONTHLY_REVIEW_DATA,
  YEARLY_REVIEW_DATA,
} from "../apollo/data"
import {
  USER_DATA_STATE,
  CURRENT_ENTRY,
  MONTHLY_REVIEW,
  YEARLY_REVIEW,
} from "../apollo/queries"
import client from "../apollo/client"
import { safeReadQuery } from "./helpers/graphql"
import { clone } from "lodash"

const STATE_KEYS = {
  userData: USER_DATA_STATE,
  currentEntry: CURRENT_ENTRY,
  monthlyReview: MONTHLY_REVIEW,
  yearlyReview: YEARLY_REVIEW,
}
const INIT_DATA = {
  userData: INIT_USER_DATA,
  currentEntry: CURRENT_ENTRY_DATA,
  monthlyReview: MONTHLY_REVIEW_DATA,
  yearlyReview: YEARLY_REVIEW_DATA,
}

export const setApolloState = (key, data, options = { merge: false }) => {
  let merged,
    nextState = {}
  const setData = data || {}
  let state = safeReadQuery(STATE_KEYS[key], { [key]: INIT_DATA[key] }, null)
  const stateItem = state[key] ? state[key] : {}
  /** Handle Reactive Variable Types */
  if (typeof stateItem === "function") {
    merged = data ? { ...stateItem(), ...setData } : clone(stateItem())
    nextState = options.merge ? merged : setData
    stateItem(nextState)
  } else {
    merged = data ? Object.assign(clone(stateItem), setData) : clone(stateItem)
    nextState[key] = options.merge ? merged : setData
    client.writeData({ data: nextState })
  }

  console.log("LOG: [setApolloState]", { key, data, options, nextState })

  // debugger
  return nextState
}

export const setAppError = data => {
  const setData = data || {}
  const update = data ? { ...ERROR_DATA, ...setData } : ERROR_DATA
  client.writeData({ data: { error: update } })
  return update
}
